<script setup>
defineEmits(['close'])

const injectedTheme = inject('theme')

const techTheme = useTechTheme()
const currentTheme = computed(() => injectedTheme?.value || techTheme.lowestLevelTheme?.value)
</script>

<template>
  <button
    tabindex="-1"
    class="absolute right-0 top-0 m-2 flex size-10 items-center justify-center rounded-full bg-ghost-white hover:text-black dark:bg-black/50 dark:hover:text-white"
    :class="currentTheme?.textColor || 'text-azure-radiance'"
    @click="$emit('close')">
    <InlineSvg
      src="/images/icon-close.svg"
      class="h-6 fill-current"
      alt="close" />
  </button>
</template>
